<template>
  <div class="c-uploads-page" @scroll="onScroll">
    <h1>Upload Media</h1>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss">
.c-uploads-page {
  height: 100vh;
  position: relative;
  overflow-y: auto;
}
</style>
